/**
 * 사용자에 의해 삭제된 댓글 상태 : REMOVED
 * 관리자에 의해 숨겨진 댓글 상태 : HIDED
 * 기본 댓글 상태 : POST
 * @enum {{removed: "REMOVED", hided: "HIDED", post: "POST"}} CommentStatusConstants
 */
export const commentStatusConstants = {
    removed: "REMOVED",
    hided: "HIDED",
    post: "POST"
};
